module.exports = __webpack_public_path__ + "static/media/Professionals.d92d9aaa.png";